import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
// import CardMake from '../views/CardMake.vue';
// import Card from '../views/Card.vue';
// import Card from "@/views/Card.vue";
import CardNew from "@/views/CardNew.vue";
import Card from "@/views/Card.vue";

import MyDrag from "@/views/drag-box.vue";
import Login from "@/views/login.vue";
import Redirection from "@/views/redirection.vue";
Vue.use(VueRouter);

const routes = [

  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/redirection",
    name: "Redirection",
    component: Redirection,
  },
  // {
  //   path: '/card-make',
  //   name: '制作答题卡',
  //   component: CardMake,
  // },
  // {
  //   path: '/card',
  //   name: '制作答题卡',
  //   component: Card,
  // },
  // {
  //   path: '/preview',
  //   name: '答题卡预览',
  //   component: Preview
  // },
  {
    path: "/card",
    name: "答题卡",
    component: Card,
  },
  {
    path: "/cardNew",
    name: "新答题卡",
    component: CardNew,
  },
  {
    path: "/drag",
    name: "拖拽",
    component: MyDrag,
  },
  {
    path: "/login",
    name: "登录页",
    component: Login,
    meta: {
      page: {
        title: "登录",
      },
    },
  },
];

const router = new VueRouter({
  routes,
});

export default router;
